import React, { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { csrfCookie, getMe } from "../api/auth";
import SplashScreen from "../components/SplashScreen";

const AuthContext = React.createContext();
const AuthProvider = ({ children }) => {
  const [loadingCsrf, setLoadingCsrf] = useState(true);
  const [loadingMe, setLoadingMe] = useState(true);
  const [apiUser, setApiUser] = useState();
  const [loggingOut, setLoggingOut] = useState(false);

  useEffect(() => {
    csrfCookie().then(() => setLoadingCsrf(false));
  }, []);

  useEffect(() => {
    getMe()
      .then((res) => setApiUser(res.data.data))
      .catch((e) => setApiUser())
      .finally(() => setLoadingMe(false));
  }, []);

  // the API reports things like "Your Zoho account has been connected" this
  // way and deletes each one once sent, so show them as they arrive
  useEffect(() => {
    if (Array.isArray(apiUser?.notifications)) {
      apiUser.notifications.forEach((x) =>
        toast(x.message, {
          type: x.type,
          autoClose: x.auto_close ? 5000 : false,
        }),
      );
    }
  }, [apiUser]);

  const hasFeature = (features) => {
    return (
      apiUser &&
      apiUser.features.length > 0 &&
      apiUser.features.some((r) => features.includes(r))
    );
  };

  const hasIntegration = (integrations) => {
    return (
      apiUser &&
      apiUser.integrations &&
      apiUser.integrations.length > 0 &&
      apiUser.integrations.some((r) => integrations.includes(r))
    );
  };

  const defaultContext = {
    apiUser,
    setApiUser,
    setLoggingOut,
    hasFeature,
    hasIntegration,
  };
  return (
    <AuthContext.Provider value={defaultContext}>
      {loadingCsrf || loadingMe || loggingOut ? (
        <SplashScreen />
      ) : (
        <>{children}</>
      )}
    </AuthContext.Provider>
  );
};

function useAuth() {
  return useContext(AuthContext);
}

export { AuthProvider, useAuth };
